import { Divider, Modal, Spin } from 'antd'
import Button from 'components/Button'
import RoutePath from 'components/RoutePath'
import Toggle from 'components/UIComponents/Toggle'
import CalenderAddIcon from 'components/icons/CalenderAddIcon'
import DownLoadIcon from 'components/icons/DownLoad'
import LeftArrow from 'components/icons/LeftArrow'
import PlusIcon from 'components/icons/PlusIcon'
import ActionDropdown from 'modules/Roles/Partials/RolesTable/ActionDropdown'
import CandidateRankingDrawer from 'modules/Roles/Partials/RolesTable/CandidateRankingDrawer'
import RoleStatus from 'modules/Roles/Partials/RolesTable/RoleStatus/index'
import EditApplicationFormDrawer from 'modules/Roles/ViewRole/Header/EditApplicationFormDrawer'
import JobDetailsDrawer from 'modules/Roles/ViewRole/Header/JobDetailsDrawer'
import ShareDrawer from 'modules/Roles/ViewRole/Header/ShareDrawer'
import {
  ActionsDiv,
  CalenderCount,
  CalenderFlex,
  CreateDriveButton,
  DrivesButton,
  LeftSection,
  PaddedDiv,
  QuestionnaireButton,
  RoleNameDiv,
  RoleNameFlex,
  SectionName,
  TopEndFlex,
  TopHeader,
} from 'modules/Roles/ViewRole/Style/style'
import TwoDrivesDrawer from 'modules/Roles/ViewRole/TwoDriveDrawer/index'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import SuccessMessage from 'utils/SuccessMessage'

import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import { useDispatch, useSelector } from 'react-redux'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'
import { permittedSubEvents } from '../../../../utils/permissionsValidation'
import { exportCandidate, setRoleDataToExcel } from '../../actions'
import Rank from './Report'
const { confirm } = Modal

const Header = ({
  tableType,
  setTableType,
  twoDrivesDrawer,
  setTwoDriveDrawer,
  singleRoleData,
  closeApplication,
  duplicateRole,
  deleteRole,
  corporateId,
  jobId,
  driveList,
  driveListLoading,
  driveModeFilter,
  setDriveModeFilter,
  getDriveDetails,
  driveDetails,
  pageLimit,
  setPageNum,
  getDriveRoleMetrics,
  driveRoleMetrics,
  getRoleAppliedDriveMetrics,
  roleAppliedDriveMetrics,
  jobSharingEmail,
  getRoleDataToExport,
  roleDataToExcel,
  candidateCount,
  filterDataForReport,
  sort,
  order,
  graphList,
}) => {
  const params = useParams()
  const [searchParams] = useSearchParams()
  const [hostCollegeDrawer, setHostCollegeDrawer] = useState('')
  const stage = searchParams.get('stage')
  const [addCollegeDrawer, setAddCollegeDrawer] = useState('')
  const [detailsDrawer, setDetailsDrawer] = useState(false)
  const [loadingRole, setLoadingRole] = useState(false)
  const [shareDrawer, setShareDrawer] = useState(false)
  const [loading, setLoading] = useState(false)
  const [rankingDrawer, setRankingDrawer] = useState(false)
  const [editFormDrawer, setEditFormDrawer] = useState(false)
  const [confirmation, setConfirmation] = useState(false)
  const [listOfDrivesDetails, setListOfDrivesDetails] = useState({})
  const [loadingExcel, setLoadingExcel] = useState(false)
  let selectedFileType = 'xlsx'
  let selectedRound = stage || 'applications'

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const onActionsClick = (jobId, action) => {
    if (action == 'close') {
      confirm({
        title: 'Close application?',
        okText: 'Confirm',
        okType: 'primary',
        cancelText: 'Cancel',
        onOk: async () => {
          const { status } = await closeApplication(jobId, setLoading)
          if (status >= 200 && status < 300) {
            navigate('/roles')
          }
        },
      })
    }
    if (action == 'duplicate') {
      confirm({
        title: 'Duplicate Role?',
        okText: 'Confirm',
        okType: 'primary',
        cancelText: 'Cancel',
        onOk: async () => {
          const { status } = await duplicateRole(jobId, setLoading)
          if (status >= 200 && status < 300) {
            navigate('/roles')
          }
        },
      })
    }
    if (action == 'delete') {
      confirm({
        title: 'Delete Role?',
        okText: 'Confirm',
        okType: 'primary',
        cancelText: 'Cancel',
        onOk: async () => {
          const { status } = await deleteRole(jobId, setLoading)
          if (status >= 200 && status < 300) {
            navigate('/roles')
          }
        },
      })
    }
  }

  const onDownloadGoogle = async () => {
    setLoadingExcel(true)
    let exportCard = []
    dispatch(
      exportCandidate(
        params?.jobId,
        selectedRound === '',
        selectedFileType,
        exportCard,
        'GOOGLE'
      )
    )
      .then(response => {
        if (response?.status >= 200 && response?.status <= 300) {
          window.open(response?.data?.data?.spreadsheetUrl)
          setLoadingExcel(false)
          SuccessMessage('Candidate list downloaded successfully!')
        } else {
          ErrorMessage(response?.response?.data?.message)
          setLoadingExcel(false)
        }
      })
      .catch(err => {
        setLoadingExcel(false)
      })
  }

  
  useEffect(() => {
    dispatch(setRoleDataToExcel())
  }, [tableType])

  const OnQuestionnaireClick = () => {
    navigate(`/questionaire-dashboard/${jobId}`)
  }
  const permission = useSelector(state => state?.auth?.permissions)

  const subEvents = permittedSubEvents(permission, 'Roles', 'Freshers')
  return (
    <>
      <PaddedDiv column>
        <TopHeader row spaceBetween alignCenter>
          <LeftSection centerVertically>
            <Link to={`/jobRoles/jobPreview/${jobId}`}>
              <LeftArrow />
            </Link>
            <SectionName column>
              <RoutePath
                from="View Role"
                on={'Fresher'}
                path={`/jobRoles/jobPreview/${jobId}`}
              />
              <RoleNameFlex alignCenter>
                <RoleNameDiv>{singleRoleData?.tittle}</RoleNameDiv>
                <RoleStatus status={singleRoleData?.status} />
              </RoleNameFlex>
            </SectionName>
          </LeftSection>
          <TopEndFlex alignCenter>
            {singleRoleData?.questionBankRoleMap?.length > 0 && (
              <QuestionnaireButton
                height={'38px'}
                text={'Questionnaire Overview'}
                onClick={OnQuestionnaireClick}
                jobId={jobId}
                singleRoleData={singleRoleData}
                pointer={graphList?.length <= 0}
              />
            )}
            {singleRoleData?.applicationFormTemplate && (
              <Button.Secondary
                text="Edit Application Form"
                onClick={() => setEditFormDrawer(true)}
                height="38px"
              />
            )}
            <ActionDropdown
              onActionsClick={onActionsClick}
              veiwButton={false}
              jobId={singleRoleData?.id}
              setRankingDrawer={setRankingDrawer}
              permittedEvents={subEvents}
            />
          </TopEndFlex>
        </TopHeader>
        <TopHeader row spaceBetween alignCenter>
          <Toggle
            left="Colleges"
            right="Candidates"
            initialValue={tableType == 'Candidates' ? 'right' : 'left'}
            onClick={ (e) =>{
              e === true ? setTableType('Candidates') : setTableType('Colleges')
            }
            }
          />
          <TopEndFlex gap={'15px'} centerVertically>
            <ActionsDiv>Actions</ActionsDiv>
            {driveList?.count ? (
              <>
                <DrivesButton
                  height="32px"
                  text={`${driveList?.count} Drives(s) Created`}
                  onClick={() => {
                    setTwoDriveDrawer(true)
                  }}
                />
                <Divider type="vertical" style={{ height: '30px' }} />
              </>
            ) : null}

            <DrivesButton
              height="32px"
              text={'Job Details'}
              onClick={() => setDetailsDrawer(true)}
            />
            <Divider type="vertical" style={{ height: '30px' }} />
            <Button.Secondary
              height={'38px'}
              icon={loadingExcel ? <Spin /> : <DownLoadIcon fill={true} />}
              text="Export to Google Sheet"
              onClick={onDownloadGoogle}
            />

            {tableType == 'Candidates' && (
              <>
                <Divider type="vertical" style={{ height: '30px' }} />
                <div>
                  {loadingRole ? (
                    <div style={{ fontSize: '18px' }}>
                      {' '}
                      <Spin /> Loading...
                    </div>
                  ) : (
                    <Rank
                      getRoleDataToExport={getRoleDataToExport}
                      jobId={jobId}
                      setLoadingRole={setLoadingRole}
                      roleDataToExcel={roleDataToExcel}
                      roleName={singleRoleData?.tittle}
                      disabled={candidateCount == 0}
                      filterDataForReport={filterDataForReport}
                      sort={sort}
                      order={order}
                    />
                  )}
                </div>
              </>
            )}
          </TopEndFlex>
        </TopHeader>
      </PaddedDiv>


      <JobDetailsDrawer
        detailsDrawer={detailsDrawer}
        setDetailsDrawer={setDetailsDrawer}
        setShareDrawer={setShareDrawer}
        singleRoleData={singleRoleData}
      />

      <ShareDrawer
        shareDrawer={shareDrawer}
        setShareDrawer={setShareDrawer}
        singleRoleData={singleRoleData}
        corporateId={corporateId}
        jobSharingEmail={jobSharingEmail}
        setDetailsDrawer={setDetailsDrawer}
      />

      <TwoDrivesDrawer
        twoDrivesDrawer={twoDrivesDrawer}
        setTwoDriveDrawer={setTwoDriveDrawer}
        driveList={driveList}
        driveListLoading={driveListLoading}
        driveModeFilter={driveModeFilter}
        setDriveModeFilter={setDriveModeFilter}
        getDriveDetails={getDriveDetails}
        driveDetails={driveDetails}
        pageLimit={pageLimit}
        setPageNum={setPageNum}
        getDriveRoleMetrics={getDriveRoleMetrics}
        driveRoleMetrics={driveRoleMetrics}
        getRoleAppliedDriveMetrics={getRoleAppliedDriveMetrics}
        roleAppliedDriveMetrics={roleAppliedDriveMetrics}
      />

      <CandidateRankingDrawer
        openDrawer={rankingDrawer}
        setOpenDrawer={setRankingDrawer}
        selectedRoleId={singleRoleData?.id}
        singleRoleData={singleRoleData}
      />

      <EditApplicationFormDrawer
        visible={editFormDrawer}
        onClose={() => setEditFormDrawer(false)}
        singleRoleData={singleRoleData}
        jobId={singleRoleData?.id}
      />

    </>
  )
}

export default Header
